(function () {
    'use strict';

    angular.module('collaterate.panels', []);
}());
